<div class="ui-g">
  <div class="ui-g-12">
    <div class="background_container">
      <div class="table-container mobile_view" style="margin-left: 15px;">
        <div class="table-row">
          <div class="table-cell" *ngIf="this.diet_plan_list && this.diet_plan_list[1]">
            <div class="plan-name" style="font-weight: 900; text-wrap: auto;">
              {{this.diet_data[0].diet_plan_name}}
              <img src="../../../../assets/images/membership_plans/Icon-awesome-angle-right.png" />
            </div>
            <div class="price notranslate">
              <span class="plan-name" style="text-decoration: line-through">{{this.diet_data[0].striked_amount}}</span><br />
              <span class="plan-name" style="font-weight: 900;">
                &nbsp;&nbsp;{{this.diet_data[0].amount}}
              </span>
              <span class="discount">/ 1 month</span><br />

              <span class="discount" style="color: green">Save {{percents_off[0]}}%</span>
              <br />
            </div>
            <div class="cell-plan-buy egd-color"> <a role="button" routerLink="../consultdoctor"
                [queryParams]="{ consultation_type_id: 5, payment_option:true ,nutrition_and_health_consultation_type_id:this.diet_plan_list[1].id}">
                Buy Plan
              </a></div>
          </div>

          <div class="table-cell" *ngIf="this.diet_plan_list && this.diet_plan_list[2]">
            <div>
              <button pButton type="button" class="bestseller_btn">
                <i class="pi pi-star"></i> &nbsp;Recommended
              </button>
            </div>
            <div class="plan-name" style="font-weight: 900;text-wrap: auto;">
              {{this.diet_data[1].diet_plan_name}}
              <img src="../../../../assets/images/membership_plans/Icon-awesome-angle-right.png" />
            </div>
            <div class="price notranslate">
              <span class="plan-name" style="text-decoration: line-through">{{this.diet_data[1].striked_amount}} </span><br />
              <span class="plan-name" style="font-weight: 900">
                &nbsp;&nbsp;{{this.diet_data[1].amount}}
              </span>
              <span class="discount">/ 2 months</span><br />
              <span class="discount" style="color: green">Save {{percents_off[1]}}%</span>
              <br />
            </div>
            <div class="cell-plan-buy egd-color"><a role="button" routerLink="../consultdoctor"
                [queryParams]="{ consultation_type_id: 5, payment_option:true ,nutrition_and_health_consultation_type_id:this.diet_plan_list[2].id}">Buy
                Plan</a></div>
          </div>

          <div class="table-cell" *ngIf="this.diet_plan_list && this.diet_plan_list[3]">
            <div class="plan-name" style="font-weight: 900;text-wrap: auto;">
              {{this.diet_data[2].diet_plan_name}}
              <img src="../../../../assets/images/membership_plans/Icon-awesome-angle-right.png" />
            </div>
            <div class="price notranslate">
              <span class="plan-name" style="text-decoration: line-through">{{this.diet_data[2].striked_amount}} </span><br />
              <span class="plan-name" style="font-weight: 900">
                &nbsp;&nbsp;{{this.diet_data[2].amount}}
              </span>
              <span class="discount">/ 3 months</span><br />

              <span class="discount" style="color: green">Save {{percents_off[2]}}%</span>
              <br />
            </div>
            <div class="cell-plan-buy egd-color"><a role="button" routerLink="../consultdoctor"
                [queryParams]="{ consultation_type_id: 5, payment_option:true ,nutrition_and_health_consultation_type_id:this.diet_plan_list[3].id}">Buy
                Plan</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ui-g-12">
    <div class="ui-g-12 mobile_view_1">
      <div class="ui-g-12">
        <div class="diet_plan_table1">
          <p class="diet_plan_title egd-color">
            Select a eGlobalDoctors Diet Plan
          </p>

          <br />
          <div class="ui-g-12 diet_plan_header">
            <div class="ui-g-3 small_screen">Features</div>
            <div class="ui-g-3 text-align-center">{{this.diet_data[0].diet_plan_name}}</div>
            <div class="ui-g-3 text-align-center" style="position: relative; background: transparent; z-index: 0">
              <div class="background-layer" style="z-index: -1; padding: 0px"></div>
              <div>{{this.diet_data[1].diet_plan_name}}</div>
              <div style="
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                ">
                <button pButton type="button" class="bestseller_btn">
                  <i class="pi pi-star"></i> &nbsp;Recommended
                </button>
              </div>
            </div>
            <div class="ui-g-3 text-align-center">{{this.diet_data[2].diet_plan_name}}</div>
          </div>

          <div class="ui-g-12 diet_plan_cell" style="border-top: 1px solid #999999; z-index: 1">
            <div class="ui-g-3" style="font-weight: 900">
              Personalized Diet Chart(Weekly)
            </div>
            <div class="ui-g-3 text-align-center cell_back">
              <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
            </div>
            <div class="ui-g-3 text-align-center">
              <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
            </div>
            <div class="ui-g-3 text-align-center">
              <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
            </div>
          </div>

          <div class="ui-g-12 diet_plan_cell" style="border-top: 1px solid #999999; z-index: 1">
            <div class="ui-g-3" style="font-weight: 900">
              Weekly Follow-Up with Dietician
            </div>
            <div class="ui-g-3 text-align-center cell_back">
              <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
            </div>
            <div class="ui-g-3 text-align-center">
              <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
            </div>
            <div class="ui-g-3 text-align-center">
              <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
            </div>
          </div>

          <div class="ui-g-12 diet_plan_cell" style="border-top: 1px solid #999999; z-index: 1">
            <div class="ui-g-3" style="font-weight: 900">
              Premium Support Care
            </div>
            <div class="ui-g-3 text-align-center cell_back">
              <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
            </div>
            <div class="ui-g-3 text-align-center">
              <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
            </div>
            <div class="ui-g-3 text-align-center">
              <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
            </div>
          </div>

          <div class="ui-g-12 diet_plan_cell" style="border-top: 1px solid #999999; z-index: 1">
            <div class="ui-g-3" style="font-weight: 900">
              Blogs, Recipies, Short Informative Videos
              <span style="color: red"> &nbsp;FREE</span>
            </div>
            <div class="ui-g-3 text-align-center cell_back">
              <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
            </div>
            <div class="ui-g-3 text-align-center">
              <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
            </div>
            <div class="ui-g-3 text-align-center">
              <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
            </div>
          </div>

          <div class="ui-g-12 diet_plan_cell" style="border-top: 1px solid #999999; z-index: 1">
            <div class="ui-g-3" style="font-weight: 900">
              Detox Diet Plan
              <span style="color: red"> &nbsp;FREE</span>
            </div>
            <div class="ui-g-3 text-align-center cell_back">
              <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
            </div>
            <div class="ui-g-3 text-align-center">
              <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
            </div>
            <div class="ui-g-3 text-align-center">
              <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
            </div>
          </div>

          <div class="ui-g-12 diet_plan_cell" style="border-top: 1px solid #999999; z-index: 1">
            <div class="ui-g-3" style="font-weight: 900">Exercise Videos</div>
            <div class="ui-g-3 text-align-center cell_back">
              <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
            </div>
            <div class="ui-g-3 text-align-center">
              <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
            </div>
            <div class="ui-g-3 text-align-center">
              <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
            </div>
          </div>

          <div class="ui-g-12 diet_plan_cell" style="border-top: 1px solid #999999; z-index: 1" *ngIf="this.posting">
            <div class="ui-g-3" style="font-weight: 900">
              Number of Consultations
            </div>
            <div class="ui-g-3 text-align-center cell_back notranslate">{{this.diet_data[0].no_of_consultations}}</div>
            <div class="ui-g-3 text-align-center cell_back notranslate">{{this.diet_data[1].no_of_consultations}}</div>
            <div class="ui-g-3 text-align-center notranslate">{{this.diet_data[2].no_of_consultations}}</div>
          </div>

          <div class="ui-g-12 diet_plan_cell buy_plan" style="z-index: 1" *ngIf="this.posting">
            <div class="ui-g-3"></div>
            <div class="ui-g-3 text-align-center cell_back_1 notranslate">
              <div>
                <span style="text-decoration: line-through">{{this.diet_data[0].striked_amount}}</span><br />
                <span class="discount">&nbsp;&nbsp; {{this.diet_data[0].amount}}</span>
                / 1 month
                <br />
                <div class="ui-g-12"></div>
                <span class="discount" style="color: green">Save {{percents_off[0]}}% </span>
                <br />
              </div>
            </div>
            <div class="ui-g-3 text-align-center cell_back_1 notranslate">
              <div>
                <span style="text-decoration: line-through">{{this.diet_data[1].striked_amount}} </span><br />
                <span class="discount">&nbsp;&nbsp; {{this.diet_data[1].amount}}</span>
                / 2 months
                <br />
                <div class="ui-g-12"></div>
                <span class="discount" style="color: green">Save {{percents_off[1]}}% </span>
                <br />
              </div>
            </div>
            <div class="ui-g-3 text-align-center cell_back_1 notranslate">
              <div>
                <span style="text-decoration: line-through">{{this.diet_data[2].striked_amount}} </span><br />
                <span class="discount">&nbsp;&nbsp; {{this.diet_data[2].amount}}</span>
                / 3 months
                <br />
                <div class="ui-g-12"></div>
                <span class="discount" style="color: green">Save {{percents_off[2]}}% </span>
                <br />
              </div>
            </div>
          </div>
          <div class="ui-g-12 diet_plan_cell" *ngIf="this.display1">
            <div class="ui-g-3"></div>
            <div class="ui-g-3 text-align-center" *ngIf="this.diet_plan_list[1]">
              <button pButton type="button" label="Buy Plan" style="border-radius: 15px" class="dashbutton cardmargin"
                [routerLink]="['../', 'consultdoctor']"
                [queryParams]="{ consultation_type_id: 5, payment_option:true ,nutrition_and_health_consultation_type_id:this.diet_plan_list[1].id}"></button>
            </div>
            <div class="ui-g-3 text-align-center" *ngIf="this.diet_plan_list[2]">
              <button pButton type="button" label="Buy Plan" style="border-radius: 15px" class="dashbutton cardmargin"
                [routerLink]="['../', 'consultdoctor']"
                [queryParams]="{ consultation_type_id: 5, payment_option:true,nutrition_and_health_consultation_type_id:this.diet_plan_list[2].id }"></button>
            </div>
            <div class="ui-g-3 text-align-center" *ngIf="this.diet_plan_list[3]">
              <button pButton type="button" label="Buy Plan" style="border-radius: 15px" class="dashbutton cardmargin"
                [routerLink]="['../', 'consultdoctor']"
                [queryParams]="{ consultation_type_id: 5, payment_option:true,nutrition_and_health_consultation_type_id:this.diet_plan_list[3].id }"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ui-g-12">
    <div class="buttonbottom margin-bottom-dashboard">
      <div class="freedietplan" style="background: #E6E3EC 0% 0% no-repeat padding-box;">
        <div class="ui-g-12 packages-dashboard-main">

          <h2 class="consultation-free egd-color text-align-center">
            Get a Diet Consultation for FREE
          </h2>
          <p class="free-plan-desc text-align-center">
            Fill this form to get a <b class="egd-color">FREE</b> diet
            assessment worth <b class="egd-color notranslate"> {{this.freeDietPrice}}</b> from
            our Expert Nutrition Coaches.
          </p>
        </div>

        <button *ngIf="this.display1 && this.diet_plan_list[0]" pButton type="button" routerLink="../consultdoctor"
          [queryParams]="{ consultation_type_id: 5, payment_option:true,nutrition_and_health_consultation_type_id:this.diet_plan_list[0].id }"
          label="Book Now" class="dashbutton cardmargin explore-plan-btn" role="button"></button>
      </div>
    </div>
  </div>
  <div class="ui-g-12">
    <div class="ui-g-12 text-center">
      <h3 class="heading3 font-weight-bolder m-3">FEATURED CATEGORIES</h3>
    </div>
    <div class="ui-g-12">
      <div class="ui-g">
        <div class="ui-lg-3 ui-md-6 ui-sm-12 my-2">
          <div class="text-center">
            <img src="../../../../assets/images/dietcategories/Diabetes Remission-min.png" alt="diabetes remission"
              class="lazyload text-center" width="100%" />
          </div>
          <h5 class="font-weight-bolder mt-2 heading4 dietsectitle">Diabetes Remission</h5>
          <p class="heading5 description">Everyone should be diabetes free and this is the motto of our Diabetes
            Remission program
            at eGlobalDoctors.</p>
          <div class="pt-5">
            <button type="button" routerLink="../consultdoctor"
              [queryParams]="{ consultation_type_id: 5, payment_option:true}" role="button"
              class="btn btn-primary btn-block booknowbtn font-weight-bolder">BOOK
              NOW</button>
          </div>
        </div>
        <div class="ui-lg-3 ui-md-6 ui-sm-12 my-2">
          <div class="text-center">
            <img src="../../../../assets/images/dietcategories/Detox Program-min.png" alt="detox program"
              class="lazyload text-center" width="100%" />
          </div>
          <h5 class="font-weight-bolder mt-2 heading4 dietsectitle">Detox program</h5>
          <p class="heading5 description">The program aims at 3 levels of detox which include Food, Body, and Mind.</p>
          <div class="pt-5">
            <button type="button" routerLink="../consultdoctor"
              [queryParams]="{ consultation_type_id: 5, payment_option:true}" role="button"
              class="btn btn-primary btn-block booknowbtn font-weight-bolder">BOOK
              NOW</button>
          </div>
        </div>
        <div class="ui-lg-3 ui-md-6 ui-sm-12 my-2">
          <div class="text-center">
            <img src="../../../../assets/images/dietcategories/Weight loss-min.png" alt="Weight Loss"
              class="lazyload text-center" width="100%" />
          </div>
          <h5 class="font-weight-bolder mt-2 heading4 dietsectitle">Weight Loss</h5>
          <p class="heading5 description">Our program aims not only in cutting down those extra pounds from your body
            but it makes
            you
            feel lighter Physically, Mentally &Emotionally.</p>
          <div class="pt-5">
            <button type="button" routerLink="../consultdoctor"
              [queryParams]="{ consultation_type_id: 5, payment_option:true}" role="button"
              class="btn btn-primary btn-block booknowbtn font-weight-bolder">BOOK
              NOW</button>
          </div>
        </div>
        <div class="ui-lg-3 ui-md-6 ui-sm-12 my-2">
          <div class="text-center">
            <img src="../../../../assets/images/dietcategories/Child Nutrition-min.png" alt="kids nutrition diet"
              class="lazyload text-center" width="100%" />
          </div>
          <h5 class="font-weight-bolder mt-2 heading4 dietsectitle">Kids Nutrition Diet</h5>
          <p class="heading5 description">Child nutrition is Healthy, fun-filled, tasty, creative and at the same time
            provides
            optimal diet habits to your child.</p>
          <div class="pt-5">
            <button type="button" routerLink="../consultdoctor"
              [queryParams]="{ consultation_type_id: 5, payment_option:true}" role="button"
              class="btn btn-primary btn-block booknowbtn font-weight-bolder">BOOK
              NOW</button>
          </div>
        </div>
      </div>

      <div class="ui-g" *ngIf="display">
        <div class="ui-lg-3 ui-md-6 ui-sm-12 my-3">
          <div class="text-center">
            <img src="../../../../assets/images/dietcategories/Gut Health-min.png" alt="gut health"
              class="lazyload text-center" width="100%" />
          </div>
          <h5 class="font-weight-bolder mt-2 heading4 dietsectitle">Gut Health</h5>
          <p class="heading5 description">Good Gut Health matters because 80% of your immune system is in the GUT and
            the majority of our body’s Serotonin (Happy Hormone) is secreted in the Gut.</p>
          <div class="pt-5">
            <button type="button" routerLink="../consultdoctor"
              [queryParams]="{ consultation_type_id: 5, payment_option:true}" role="button"
              class="btn btn-primary btn-block booknowbtn font-weight-bolder">BOOK
              NOW</button>
          </div>
        </div>
        <div class="ui-lg-3 ui-md-6 ui-sm-12 my-3">
          <div class="text-center">
            <img src="../../../../assets/images/dietcategories/Menopause-min.png" alt="menopause nutrition support"
              class="lazyload text-center" width="100%" />
          </div>
          <h5 class="font-weight-bolder mt-2 heading4 dietsectitle">Menopause Nutrition Support</h5>
          <p class="heading5 description">To empower every woman through a wonderful phase of mid-life and her unique
            menopausal journey.</p>
          <div class="pt-5">
            <button type="button" routerLink="../consultdoctor"
              [queryParams]="{ consultation_type_id: 5, payment_option:true}" role="button"
              class="btn btn-primary btn-block booknowbtn font-weight-bolder">BOOK
              NOW</button>
          </div>
        </div>
        <div class="ui-lg-3 ui-md-6 ui-sm-12 my-3">
          <div class="text-center">
            <img src="../../../../assets/images/dietcategories/Reversal of PCOS-min.png" alt="reversal of pcos"
              class="lazyload text-center" width="100%" />
          </div>
          <h5 class="font-weight-bolder mt-2 heading4 dietsectitle">Reversal of PCOS & Hypothyroidism</h5>
          <p class="heading5 description">PCOS and certain types of hypothyroidism are reversible by the following
            approach. We are able to achieve that quite successfully with our clients.</p>
          <div class="pt-5">
            <button type="button" routerLink="../consultdoctor"
              [queryParams]="{ consultation_type_id: 5, payment_option:true}" role="button"
              class="btn btn-primary btn-block booknowbtn font-weight-bolder">BOOK
              NOW</button>
          </div>
        </div>
        <div class="ui-lg-3 ui-md-6 ui-sm-12 my-3">
          <div class="text-center">
            <img src="../../../../assets/images/dietcategories/Sports nutrition-min.png" alt="sports nutrition"
              class="lazyload text-center" width="100%" />
          </div>
          <h5 class="font-weight-bolder mt-2 heading4 dietsectitle">Sports Nutrition</h5>
          <p class="heading5 description">Sports nutrition is not only about providing the essential fuels but it is
            also about effective utilization of the same by the body, which eventually strengthens the body and provides
            the ability to perform and improve endurance.</p>
          <div class="pt-5">
            <button type="button" routerLink="../consultdoctor"
              [queryParams]="{ consultation_type_id: 5, payment_option:true}" role="button"
              class="btn btn-primary btn-block booknowbtn font-weight-bolder">BOOK
              NOW</button>
          </div>
        </div>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="text-align-center notranslate">
        <button pButton type="button" (click)="display = !display;" [label]="display ? 'Show Less' : 'View More'"
          class="dashbutton cardmargin commonhealthbtn viewbtn" style="text-align: center;
          font: normal normal 600 20px/24px Montserrat;
          letter-spacing: 0px;
          color: #004AAD;
          margin-top: 20px;
          background: #FFFFFF 0% 0% no-repeat padding-box;
          border: 1px solid #004AAD;
          border-radius: 10px;
          opacity: 1;" role="button"></button>
      </div>
    </div>

  </div>

</div>